export class Timestamp { public static readonly stamp = '1662648231772'; }